import { RootState } from "store";


function selectCategories(state: RootState) {
  return state.inventory.categories;
}

export { selectCategories }
